export const orderStatusOptions = [
  { value: "PENDING", label: "Pending", arabic_label: "قيد الانتظار" },
  { value: "PAID", label: "Paid", arabic_label: "مدفوع" },
  { value: "COMPLETED", label: "Completed", arabic_label: "مكتمل" },
];
